import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  styleUrl: './bread-crumbs.component.scss',
  template: `
    <nav *ngIf="breadcrumbs.length" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let bc of breadcrumbs; let last = last">
          <a *ngIf="!last" [routerLink]="bc.url">{{ bc.label }}</a>
          <span *ngIf="last" [routerLink]="bc.url">{{ bc.label }}</span>
        </li>
      </ol>
    </nav>
  `
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<{ label: string, url: string }> = [];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = [];
        this.buildBreadcrumbs(this.route.root, '');
      });
  }

  private buildBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: any[] = []): void {
    const children = route.children;
  
    for (const child of children) {
      const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
        const label = child.snapshot.data['breadcrumb'] || this.capitalize(routeURL);
        this.breadcrumbs.push({ label, url });
      }
      this.buildBreadcrumbs(child, url, breadcrumbs);
    }
  }

  private capitalize(str: string): string {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
  }
  
}